<script>
	import {
		h
	} from 'vue'; // onMounted,reactive,ref,
	export default {
		props: {
			detail: {
				type: Object,
				default () {
					return {};
				}
			},
			title: {
				type: String,
				default () {
					return '';
				}
			}
		},
		setup(props, {
			emit
		}) {
			function addVode(iconUrl, arrVode, text, content) {
				arrVode.push(h('div', {
						class: 'bar'
					},
					[h('div', {
							class: 'title'
						},
						[h('img', {
							class: 'imgStyle',
							src: iconUrl
						}), h('div', {
							class: 'name'
						}, text)]
					), h('div', {
						class: 'divText'
					}, content)]
				));
			}
			return () => h('div', {
				class: 'pop'
			}, (function() {
				let regex = /.?Address.?$/i;
				let regex1 = /.?WebLink.?$/i
				let regex2 = /.?ContactNumber.?$/i
				let regex3 = /.?intro.?$/i;
				let arrVode = [];
				arrVode.push(h('div', {
						class: 'top'
					},
					[h('div', {
						class: 'title'
					}, props.title), h('img', {
						class: 'closeImg',
						src: 'close.png',
						onClick: () => {
							emit('closePop');
						}
					})]
				));
				for (let prop in props.detail) {
					if (props.detail[prop]) {
						if (regex.test(prop)) {
							addVode('address.png', arrVode, '地址', props.detail[prop])
						} else if (regex1.test(prop)) {
							addVode('eye.png', arrVode, '网址', props.detail[prop])
						} else if (regex2.test(prop)) {
							addVode('phone.png', arrVode, '电话', props.detail[prop])
						} else if (regex3.test(prop)) {
							arrVode.push(h('div', {
									class: 'bar'
								},
								[h('div', {
									class: 'title'
								}, [
									h('img', {
										class: 'imgStyle',
										src: 'intro.png'
									}), h('div', {
										class: 'name'
									}, '简介')
								]), h('div', {
									class: 'divText',
									innerHTML: props.detail[prop]
								})]
							));
						} else if (prop == "hotIndustryOverview") {
							addVode('star.png', arrVode, '产业概述', props.detail[prop])
						} else if (prop == "hotIndustryAdvantage") {
							addVode('star.png', arrVode, '投资优势', props.detail[prop])
						}
						//   else if(prop == "hotIndustrySuggestArea"){
						//      addVode('phone.png',arrVode,props.detail[prop])
						//   }
					}

				}
				return arrVode;
			})())
		}
	}
</script>
<style lang="scss" scoped>
	.pop {
		position: absolute;
		left: 50%;
		top: 50%;
		width: 75%;
		z-index: 999;
		background: #fff;
		padding: 15px;
		transform: translate(-50%, -50%);
		border-radius: 5px;

		.top {
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding-bottom: 10px;

			.title {
				font-size: 18px;
				font-weight: bold;
			}

			.closeImg {
				width: 20px;
				height: 20px;
			}
		}

		.bar {
			margin-top: 10px;

			.title {
				display: flex;
				justify-content: left;
				align-items: center;

				.imgStyle {
					width: 20px;
					height: 20px;
				}

				.name {
					padding-left: 5px;
				}
			}


			.divText {
				border-bottom: 1px solid #ccc;
				padding-bottom: 5px;
				font-size: 14px;
				max-height: 150px;
				overflow: auto;
				padding: 10px 0px;
				text-indent: 2em;
				text-align: justify;
			}
		}
	}
</style>